import type { FaireProductEntity } from "../../entity_types/product";

export const p_egt7frp2w7: FaireProductEntity = {
  token: "p_egt7frp2w7",
  type: "product",
  name: "Shell & Sand Filled Holiday Disc Ornament | Customizable\u00a0",
  brandName: "Salty Sea Company",
  imageUrl:
    "https://cdn.faire.com/fastly/ab21cd74c96ce5374728ce3a63668ed033dee3897e65ffaf9845dafe10936fa3.jpeg",
  priceDollars: 90,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/d9948a3f67781ba48b2a7045f9f412c089083fca37e6c8b9407608c91726c3c3.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
